import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, Phone, Facebook } from 'lucide-react';
import { Button } from './ui/button';

export const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  const navLinks = [
    { name: 'Home', path: '/' },
    { name: 'Resources', path: '/resources' },
    { name: 'The Book', path: '/book' },
    { name: 'Blog', path: '/blog' },
    { name: 'About', path: '/about' }
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <nav className="bg-white shadow-md sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center">
            <h1 className="text-2xl font-bold text-teal-700">
              Two Sandwiches & A Nap
            </h1>
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-6">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`text-base font-medium transition-colors duration-200 ${
                  isActive(link.path)
                    ? 'text-teal-700 font-semibold'
                    : 'text-gray-700 hover:text-teal-600'
                }`}
              >
                {link.name}
              </Link>
            ))}
            <a
              href="https://www.facebook.com/twosandwichesandanap"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-700 hover:text-teal-600 transition-colors duration-200"
            >
              <Facebook className="w-6 h-6" />
            </a>
            <a href="tel:988">
              <Button className="bg-red-600 hover:bg-red-700 text-white">
                <Phone className="mr-2 w-4 h-4" />
                Crisis: 988
              </Button>
            </a>
          </div>

          {/* Mobile menu button */}
          <button
            onClick={() => setIsOpen(!isOpen)}
            className="md:hidden p-2 rounded-lg text-gray-700 hover:bg-gray-100 transition-colors duration-200"
          >
            {isOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </div>

      {/* Mobile Navigation */}
      {isOpen && (
        <div className="md:hidden border-t border-gray-200 bg-white">
          <div className="px-4 pt-2 pb-4 space-y-2">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                onClick={() => setIsOpen(false)}
                className={`block px-3 py-2 rounded-lg text-base font-medium transition-colors duration-200 ${
                  isActive(link.path)
                    ? 'bg-teal-50 text-teal-700'
                    : 'text-gray-700 hover:bg-gray-50'
                }`}
              >
                {link.name}
              </Link>
            ))}
            <a
              href="https://www.facebook.com/twosandwichesandanap"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center px-3 py-2 text-gray-700 hover:bg-gray-50 rounded-lg"
            >
              <Facebook className="w-5 h-5 mr-2" />
              Follow on Facebook
            </a>
            <a href="tel:988" className="block mt-4">
              <Button className="w-full bg-red-600 hover:bg-red-700 text-white">
                <Phone className="mr-2 w-4 h-4" />
                Crisis Helpline: 988
              </Button>
            </a>
          </div>
        </div>
      )}
    </nav>
  );
};
